<template>

<div v-if="item.formType == 'input'">

  <Input :item="item"/>

</div>
<div v-else-if="item.formType == 'submit'">

  <Submit :item="item"/>

</div>
<div v-else-if="item.formType == 'notification'">

  <Notification :item="item"/>

</div>
<div v-else>

  <div class="form-text">
    <Small :text="$t(item.text)"/>
  </div>

</div>

</template>

<script>
import Input from './Input.vue'
import Submit from './Submit.vue'
import Notification from './Notification.vue'
import Small from '../texts/Small.vue'

export default {
  name: 'FormElement',
  props: {
    item: Object
  },
  components: {
    Input,
    Submit,
    Notification,
    Small
  }
}
</script>

<style lang="scss" scoped>
.form-text {
  color: #bac6e6;
  margin: 10px;
}
</style>
